import { render } from "./PopImage.vue?vue&type=template&id=1434ec82&scoped=true&ts=true&lang=pug"
import script from "./PopImage.vue?vue&type=script&lang=ts"
export * from "./PopImage.vue?vue&type=script&lang=ts"

import "./PopImage.vue?vue&type=style&index=0&id=1434ec82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1434ec82"]])

export default __exports__